import { createApiClient } from '@iris/shared';
import { createAuthBridge } from '@iris/ui/lib/auth-helpers';

/** Connects the client's refreshed and lost sessions to the AuthProvider (M6). */
export const authBridge = createAuthBridge();

/** The selected shop, sent as `X-Merchant-Id` on every request (ADR 0001 D8); set by ShopProvider. */
export const selectedMerchant: { id: string | null } = { id: null };

/**
 * The merchant app's API client (T4 §2.1). Same origin: `/api` is proxied in development and routed by Caddy in
 * production. A lost session sends the user to /login with the return URL (RequireAuth).
 */
export const apiClient = createApiClient({
  baseUrl: '',
  app: 'MERCHANT',
  appVersion: __APP_VERSION__,
  getLocale: () => (document.documentElement.lang === 'ar' ? 'ar' : 'fr'),
  getMerchantId: () => selectedMerchant.id,
  onAuthLost: authBridge.onAuthLost,
  onSession: authBridge.onSession,
});
